// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-search-btn{height:36px;line-height:36px;padding:0 20px}.el-dialog__body{padding:10px 20px 10px!important}.el-dialog__body p{line-height:30px}.error-tip{color:red}", ""]);
// Exports
module.exports = exports;
